import { render, staticRenderFns } from "./WalletMobileSuggesterComponent.vue?vue&type=template&id=2fe366fc&scoped=true"
import script from "./WalletMobileSuggesterComponent.vue?vue&type=script&lang=js"
export * from "./WalletMobileSuggesterComponent.vue?vue&type=script&lang=js"
import style0 from "./WalletMobileSuggesterComponent.vue?vue&type=style&index=0&id=2fe366fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe366fc",
  null
  
)

export default component.exports